import { SingleNews } from '@toggle/toggle';

import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/query-params';
import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';
import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';

export const useArticleDrawer = (source: PosthogTrackingSource) => {
  const { params, deleteQueryParam, setQueryParams } = useQueryParams();
  const { trackNewsDrawerOpen } = usePosthogEvents();

  const handleSelectSingleNews = (article: SingleNews) => {
    trackNewsDrawerOpen(source);
    setQueryParams({
      [queryKeys.activeArticleId]: article?.id,
      [queryKeys.activeDrawer]: 'article',
    });
  };

  const closeDrawer = () => {
    deleteQueryParam([queryKeys.activeArticleId, queryKeys.activeDrawer]);
  };

  return {
    handleSelectSingleNews,
    closeDrawer,
    singleNewsId: params.activeArticleId,
  };
};
